export default __webpack_public_path__ + "static/media/Letter F.0ab924bb.mov";